import React, { useState, useRef, useEffect } from "react";
import { Play, Pause, Heart, Wind, Moon, Feather, Sun, Cloud, MusicNote, CloudRain, Drop } from "@phosphor-icons/react";
import PageHeader from "../components/PageHeader";
import { MEDITATIONS } from "../data/staticData";

const ICONS = { Heart, Wind, Moon, Feather, Sun, Cloud, MusicNote, CloudRain, Drop };

export default function Meditation() {
  const [playingId, setPlayingId] = useState(null);
  const audioRef = useRef(null);

  useEffect(() => () => { if (audioRef.current) audioRef.current.pause(); }, []);

  const toggle = (med) => {
    if (playingId === med.id) {
      audioRef.current.pause();
      setPlayingId(null);
      return;
    }
    if (audioRef.current) audioRef.current.pause();
    const audio = new Audio(med.audio);
    audio.onended = () => setPlayingId(null);
    audio.onerror = () => setPlayingId(null);
    audioRef.current = audio;
    audio.play().then(() => setPlayingId(med.id)).catch(() => setPlayingId(null));
  };

  return (
    <div>
      <PageHeader title="Méditation & respiration" subtitle="Un souffle rien que pour vous" />

      <div className="space-y-4 px-6">
        {MEDITATIONS.map((med, i) => {
          const Icon = ICONS[med.icon] || Heart;
          const active = playingId === med.id;
          return (
            <div
              key={med.id}
              data-testid={`meditation-card-${med.id}`}
              className="fade-up flex items-center gap-4 overflow-hidden rounded-[26px] p-5 shadow-[0_6px_24px_rgba(54,48,43,0.06)]"
              style={{
                background: `linear-gradient(135deg, ${med.gradient[0]}, ${med.gradient[1]})`,
                animationDelay: `${i * 45}ms`,
              }}
            >
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-white/25">
                <Icon size={26} color="#FFFFFF" weight="fill" />
              </div>
              <div className="flex-1 text-white">
                <p className="font-display text-[17px] font-medium leading-tight">{med.title}</p>
                <p className="text-[13px] text-white/85">{med.subtitle}</p>
                <p className="mt-1 text-[11.5px] font-semibold uppercase tracking-wide text-white/70">
                  {med.duration}
                </p>
              </div>
              <button
                data-testid={`meditation-play-${med.id}`}
                onClick={() => toggle(med)}
                className="flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-sm transition-transform hover:scale-105"
                aria-label={active ? "Pause" : "Lecture"}
              >
                {active ? (
                  <Pause size={22} color="#36302B" weight="fill" />
                ) : (
                  <Play size={22} color="#36302B" weight="fill" />
                )}
              </button>
            </div>
          );
        })}
      </div>

      <p className="mt-6 px-6 text-center text-[12px] leading-relaxed text-[#36302B]/45">
        Sons piano solo & nature (domaine public). À écouter même à 3h du matin, sans réveiller bébé.
      </p>
    </div>
  );
}
